import { post } from '../index';

const changeAdmin = body => {
  return post('/company/admin', body);
};

export { changeAdmin };
